import { render, staticRenderFns } from "./RegisterInfo.vue?vue&type=template&id=2ad4c931&scoped=true&"
import script from "./RegisterInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegisterInfo.vue?vue&type=style&index=0&id=2ad4c931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4c931",
  null
  
)

export default component.exports